import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { CategoryService, DonationRequestDto, FamilyService, NoteRequestDto, NoteService } from 'src/app/backend';
import { DonationService } from '../../../backend/api/donation.service';
import { MemberRequestDto } from '../../../backend/model/memberRequestDto';
import { SexEnum } from '../../../backend/model/sexEnum';
import { BaseComponent } from '../../../core/components/base/base.component';
import { DialogRef } from '../../../core/dialog/dialog-ref';
import { DialogConfig } from '../../../core/dialog/dialog.service';
import { AuthService } from '../../../core/services/auth.service';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';


@Component({
  templateUrl: './save-note-dialog.component.html',
  //   styleUrls: ['./save-user-dialog.component.scss'],
})

export class SaveNoteDialogComponent extends BaseComponent {
  searchQueryControl = new UntypedFormControl('');
  SexEnum = SexEnum;
  form = new UntypedFormGroup({});
  id = 0;
  familyId = 0;
  categoryId = 0;
  isLoading = false;
  isSaving = false;

  constructor(
    private dialogConfig: DialogConfig,
    private dialogRef: DialogRef,
    private t: TranslateService,
    private noteService: NoteService,
    authService: AuthService,
    messageService: NzMessageService
  ) {
    super(authService, t, messageService);
    const config = this.dialogConfig;
    this.id = config.data?.id;
    this.familyId = config.data?.familyId;

    this.form = new UntypedFormGroup({
      name: new UntypedFormControl(''),
      description: new UntypedFormControl(''),
      familyId: new UntypedFormControl(0),
      id: new UntypedFormControl(0),
    });
  }

  close(saved?: boolean) {
    this.dialogRef.close({ saved });
  }

  save() {
    if (!this.form.valid) {
      for (const i in this.form.controls) {
        this.form.controls[i].markAsDirty();
        this.form.controls[i].updateValueAndValidity();
      }
      return;
    }

    const data: NoteRequestDto = {
      familyId: this.familyId,
      name: this.form.value.name,
      description: this.form.value.description,
      id: this.form.value.id
    };

    console.log(data);
    const apiCall = this.noteService.apiNotePost({ noteRequestDto: data });

    this.isSaving = true;

    apiCall.subscribe(
      (res: any) => {
        this.isSaving = false;
        this.close(true);
      },
      (err: any) => {
        this.isSaving = false;
        this.errorHandler(err, this.form);
      }
    );
  }

  disabledEndDate = (endValue: Date): boolean => {
    if (endValue.getDate() < new Date().getDate()) {
      return false;
    }

    return true;
  }
}
